var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 37622"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 4",
    d: "M22.1313 44C34.2091 44 44 34.2091 44 22.1313C44 10.0536 34.2091 0.262695 22.1313 0.262695C10.0536 0.262695 0.262695 10.0536 0.262695 22.1313C0.262695 34.2091 10.0536 44 22.1313 44Z",
    fill: "#EE3364"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 37621"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.0791 22.1315L31.8257 22.1315",
    stroke: "white",
    strokeWidth: 2.15445,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.4355 15.6681H31.8256",
    stroke: "white",
    strokeWidth: 2.15445,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M23.5098 28.5947L31.8259 28.5947",
    stroke: "white",
    strokeWidth: 2.15445,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/MenuIcon.e6cf7fd4067a0a0345db15ad8a02b7a5.svg";
export { ForwardRef as ReactComponent };